import { createFileRoute } from "@tanstack/react-router";

import { ProjectsEntry } from "./-ProjectsEntry";

export const Route = createFileRoute("/_console/projects/")({
  component: ProjectsEntry,
});
